import React from "react";

const Error404 = () => {
  return <h3>Placeholder Error Page for 404 page not found</h3>;
};

export default Error404;
